(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      const sliders = document.querySelectorAll('[data-banner-slider]');
  
      sliders.forEach(container => {
        const slides = container.querySelectorAll('.banner-slide');
        const totalSlides = slides.length;
  
        // Skip if only one slide
        if (totalSlides <= 1) return;
  
        let currentSlide = 0;
        let slideInterval;
        const interval = parseInt(container.dataset.slideInterval) || 4000;
        const autoSlide = container.dataset.autoSlide === 'true';
  
        function showSlide(index) {
          slides.forEach(slide => {
            slide.style.opacity = '0';
            slide.style.pointerEvents = 'none';
          });
          slides[index].style.opacity = '1';
          slides[index].style.pointerEvents = 'auto';
          currentSlide = index;
        }
  
        function nextSlide() {
          showSlide((currentSlide + 1) % totalSlides);
        }
  
        function startSlider() {
          if (autoSlide) {
            slideInterval = setInterval(nextSlide, interval);
          }
        }
  
        function stopSlider() {
          clearInterval(slideInterval);
        }
  
        // Initialize
        showSlide(0);
        startSlider();
  
        // Pause on hover
        container.addEventListener('mouseenter', stopSlider);
        container.addEventListener('mouseleave', startSlider);
      });
    });
  
  } catch(e) { console.error(e); }
})();
})();
